@if (src) {
    <div fxLayout="column" fxLayoutAlign="center center" class="p-24 dialog-container position-relative">
        <div class="h3-semi-bold c-primary-gray-900">{{ 'i18n_af_dialogResolutionPreviewDialogTitle' | translate }}</div>
        <ui-kit-svg class="i-24 pointer icon c-primary-gray-200" name="ic_cross" (click)="dialogRef.close()"/>
        <div class="w-100 radius-16 mt-24 bc-primary-gray-100" fxLayoutAlign="center center">
            <pdf-viewer class="pdf-container"
                        [src]="src"
                        [render-text]="false"
                        [original-size]="false"/>
        </div>
    </div>
}
